<sc-padding fitHeight>
  <sc-flex vertical stretchContent fitHeight>

    <sc-padding>
      <sc-flex centered>
        <sc-content-spacer grow></sc-content-spacer>
        <sc-action-icon iconClass="fa-magnifying-glass" (click)="openFindElementDialog()"
          [disabled]="areaGateReference == null"></sc-action-icon>
        <sc-content-spacer double></sc-content-spacer>
        <sc-action-icon iconClass="fa-input-text" (click)="openFindElementDialog()"
          [disabled]="areaGateReference == null"></sc-action-icon>
        <sc-content-spacer double></sc-content-spacer>
        <sc-action-icon iconClass="fa-qrcode-read" (click)="openFindElementDialog()"
          [disabled]="areaGateReference == null"></sc-action-icon>
        <sc-content-spacer grow></sc-content-spacer>
        <sc-action-icon iconClass="fa-gear-complex" (click)="openSelectGateDialog()"></sc-action-icon>
      </sc-flex>
    </sc-padding>

    <sc-content-spacer vertical></sc-content-spacer>

    <ng-container *ngIf="areaGateReference != null">
        <sc-flex centered>
          <sc-hint-legacy dictionaryKey="tmc-common.common.enum.direction.{{areaGateReference.direction}}"></sc-hint-legacy>
          <sc-content-spacer></sc-content-spacer>
          {{areaGateReference?.name}}
        </sc-flex>
    </ng-container>

    <sc-content-spacer vertical></sc-content-spacer>

    <sc-flex-fitting-content vertical>
      <sc-no-data-container [hasData]="gateKeepingCase != null" fitHeight>
        <sc-scroll-pane>

          <sc-tile>
            <app-gate-keeper-candidate-details
              [gateKeepingCandidate]="gateKeepingCase?.candidate"></app-gate-keeper-candidate-details>
          </sc-tile>

          <sc-content-spacer vertical></sc-content-spacer>

          <sc-hint-legacy dictionaryKey="tmc-common.gate-keeping.ui.gate-keeper-control.hints-title"></sc-hint-legacy>
          <sc-content-spacer vertical></sc-content-spacer>

          <sc-no-data compact *ngIf="gateKeepingCase?.hints.length === 0"></sc-no-data>
          <sc-hint [hint]="hint" *ngFor="let hint of gateKeepingCase?.hints"></sc-hint>

          <sc-content-spacer vertical></sc-content-spacer>

          <sc-hint-legacy dictionaryKey="tmc-common.gate-keeping.ui.gate-keeper-control.tasks-title"></sc-hint-legacy>
          <sc-content-spacer vertical></sc-content-spacer>

          <sc-no-data compact *ngIf="gateKeepingCase?.tasks.length === 0"></sc-no-data>
          <app-task-execution [taskExecution]="task" *ngFor="let task of gateKeepingCase?.tasks" (changed)="onTaskChanged()"
          [metaData]="taskMetaData"></app-task-execution>

          <sc-content-spacer vertical></sc-content-spacer>

          <sc-cancel-button fitWidth (click)="handleCancel()"></sc-cancel-button>
          <sc-content-spacer vertical></sc-content-spacer>
          <sc-button iconClass="fa-hand" [dictionaryKey]="declineLabel"
            (click)="decline()" fitWidth></sc-button>
          <sc-content-spacer vertical></sc-content-spacer>
          <sc-button iconClass="fa-check" (click)="confirm()"
            [dictionaryKey]="confirmLabel" fitWidth
            [disabled]="!gateKeepingCase?.candidate?.entranceAllowed" primary></sc-button>

        </sc-scroll-pane>
      </sc-no-data-container>
    </sc-flex-fitting-content>

  </sc-flex>
</sc-padding>
